<template>
  <div class="auth-page">
    <b-container>
      <h5 class="auth-logo">
        <i class="fa fa-circle text-primary"></i>
        Ekhoni Daktar
        <i class="fa fa-circle text-danger"></i>
      </h5>
      <Widget class="widget-auth mx-auto" customHeader>
       <div style="margin-left: 12.5%; margin-bottom: 3%;">
         <b-row>
           <img src="./../../../assets/images/app_icon.png" style="border-radius: 50%; margin-right: 15px;" height="40" width="40" alt="app logo"/>
           <div style="margin-top: 5px;">
             <h3 class="mt-0">Ekhoni Doctor</h3>
           </div>
         </b-row>
       </div>
        <p class="widget-auth-info">
            Use your phone number to login.
        </p>
        <form class="mt" @submit.prevent="login">
          <b-alert class="alert-sm" variant="danger" :show="!!errorMessage">
            {{errorMessage}}
          </b-alert>
          <div class="form-group">
            <input class="form-control no-border" required type="text" name="mobile" placeholder="Mobile number" v-model="login_form.mobile" />
          </div>
          <div class="form-group">
            <input class="form-control no-border" required type="password" name="password" placeholder="Password" v-model="login_form.password"/>
          </div>
          <b-button size="sm" class="auth-btn mb-3" variant="inverse" @click="requestLogin">Login</b-button>
        </form>
      </Widget>
    </b-container>
  </div>
</template>

<script>
import Widget from '@/components/admin/Widget/Widget';
import { Form } from 'vform';
import {mapActions, mapGetters} from 'vuex';
import AuthService from "@/services/admin/auth.service";

export default {
  name: 'LoginPage',
  components: { Widget },
  data() {
    return {
      errorMessage: null,
      login_form:new Form(
          {
            mobile: '',
            password: ''
          }
      ),
    };
  },
  computed:{
    ...mapGetters('adminAuth', ['getUser']),
  },
  methods: {
    ...mapActions('adminAuth', ['storeAdminUser']),
    requestLogin() {
      AuthService.login(this.login_form)
          .then((resposne) => {
            console.log(resposne);
            if (resposne.status === 200) {
              this.storeAdminUser(resposne.data);
              this.$router.push('/admin/dashboard');
            }
          })
    }
  },
  mounted() {
    if(this.getUser){
      this.$router.push('/admin/dashboard');
    }
  }
};
</script>
